module.exports = __webpack_public_path__ + "img/2850aa7.png";